import {
  Flex,
  Modal,
  Typography,
  Separator,
  Details,
  theme,
  Box,
  Link,
  ScreenReaderOnly,
} from '@fe-toolkit/web-components/ssr'

import content from '@/content/content'
import {
  esimDevices as esimCompatibilityList,
  ManufacturerSection,
} from '@/constants/esimDevices'

type EsimCompatibilityModalProps = {
  display: boolean
  setDisplay: (display: boolean) => void
  esimDevices?: ManufacturerSection[]
}

const EsimCompatibilityModal = ({
  display,
  setDisplay,
  esimDevices = esimCompatibilityList,
}: EsimCompatibilityModalProps) => {
  const { eSimCompatibilityModal } = content
  return (
    <Modal
      closeModal={() => setDisplay(false)}
      disableScrolling={true}
      display={display}
      modalBackgroundColour="wildSand"
      setDisplay={setDisplay}
      title={eSimCompatibilityModal.title}
    >
      <Separator colour="black" height="2px" />
      <Flex
        flexDirection="column"
        gap={theme.spacing.small}
        p={theme.spacing.medium}
      >
        <Typography as={'p'} variant={'speak'}>
          {eSimCompatibilityModal.description}
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {eSimCompatibilityModal.alternativeCompatibilityCheckDescriptionPart1}
          <Typography aria-hidden={true} variant={'speakUp'}>
            {
              eSimCompatibilityModal.alternativeCompatibilityCheckDescriptionPart2
            }
          </Typography>
          <ScreenReaderOnly>
            {
              eSimCompatibilityModal.screenReaderOnly_AlternativeCompatibilityCheckDescriptionPart2
            }
          </ScreenReaderOnly>
          <Typography variant={'speak'}>
            {
              eSimCompatibilityModal.alternativeCompatibilityCheckDescriptionPart3
            }
          </Typography>
        </Typography>
        {esimDevices.map(({ manufacturer, groups }) => (
          <Details key={manufacturer} summary={manufacturer}>
            <Flex flexDirection={'column'} gap={theme.spacing.fine}>
              {groups.map(({ brand, devices }, groupIndex) => (
                <Box key={brand || groupIndex}>
                  {brand && (
                    <Typography
                      as="p"
                      mb={theme.spacing.fine}
                      mt={groupIndex > 0 ? theme.spacing.fine : undefined}
                      variant="speakUp"
                    >
                      {brand}
                    </Typography>
                  )}
                  <ul>
                    {devices.map(device => (
                      <li key={device}>{device}</li>
                    ))}
                  </ul>
                </Box>
              ))}
            </Flex>
          </Details>
        ))}
        <Box marginTop={theme.spacing.large} textAlign="center">
          <Link as={'button'} onClick={() => setDisplay(false)}>
            {content.modalCloseLinkLabel}
          </Link>
        </Box>
      </Flex>
    </Modal>
  )
}

export default EsimCompatibilityModal
